export const cannotBeEmpty = "Cannot be empty."